import { render, staticRenderFns } from "./sysSchool.vue?vue&type=template&id=b66ed224&"
import script from "./sysSchool.vue?vue&type=script&lang=js&"
export * from "./sysSchool.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports